// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import GridContainer, { GridContainerProps } from "@keller/MobiusOverrides/GridContainer";
import sharedAddressesStyles from "@keller/Overrides/Widgets/CheckoutShipping/SharedAddresses.style";
import { ShippingAddressInfo } from "@keller/XDL/types";
import React, { useState } from "react";

export interface checkoutShippingPickUpShippingAddressInfoStyles {
    container?: GridContainerProps;
    headingGridItem?: GridItemProps;
    headingText?: TypographyPresentationProps;
    addressDisplayAndFormGridItem?: GridItemProps;
    addressDisplay?: AddressInfoDisplayStyles;
}

export const checkoutShippingPickUpShippingAddressInfoStyles: checkoutShippingPickUpShippingAddressInfoStyles = {
    container: {
        ...sharedAddressesStyles.container,
    },
    headingGridItem: {
        ...sharedAddressesStyles.headingGridItem,
    },
    headingText: {
        ...sharedAddressesStyles.headingText,
    },
    addressDisplayAndFormGridItem: {
        ...sharedAddressesStyles.addressDisplayGridItem,
    },
};

type OwnProps = {
    shippingAddressInfo: ShippingAddressInfo;
    extendedStyles?: checkoutShippingPickUpShippingAddressInfoStyles;
};

type Props = OwnProps;

const CheckoutShippingPickUpShippingAddressInfo: React.FunctionComponent<Props> = ({
    shippingAddressInfo,
    extendedStyles,
}) => {
    const [styles] = useState(() => mergeToNew(checkoutShippingPickUpShippingAddressInfoStyles, extendedStyles));

    return (
        <GridContainer {...styles.container} data-test-selector="checkoutShipping_shippingAddress">
            <GridItem {...styles.headingGridItem}>
                <Typography {...styles.headingText} as="h3">
                    {translate("Shipping Address")}
                </Typography>
            </GridItem>
            <GridItem {...styles.addressDisplayAndFormGridItem}>
                <AddressInfoDisplay {...shippingAddressInfo} />
            </GridItem>
        </GridContainer>
    );
};

export default CheckoutShippingPickUpShippingAddressInfo;
